import { render } from "./AdminApproved25Liquidations.vue?vue&type=template&id=6845c5c6"
import script from "./AdminApproved25Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminApproved25Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__